module.exports = __webpack_public_path__ + "img/layer.29ffce19.png";